<template>
  <BaseCard>
    <BaseCardHeader>
      <h3 class="text-base truncate">
        {{ audience.name }}
      </h3>
    </BaseCardHeader>
    <div class="aspect-w-16 aspect-h-9 bg-gray-100">
      <img
        v-if="audience.cover && audience.cover.url"
        :src="audience.cover.url"
        :alt="audience.cover.name"
        class="w-full h-full object-cover"
      />
    </div>
    <BaseCardBody>
      <dl class="grid grid-cols-1 gap-y-8">
        <div>
          <dt class="text-sm font-medium text-gray-500">Audience stage</dt>
          <dd class="mt-1 text-sm text-gray-900">
            {{ audience.stageName }}
          </dd>
        </div>
      </dl>
      <template v-if="audience.model">
        <AudienceCardFacebookDetails v-if="isFacebookAudience" :audience="audience" class="mt-8" />
        <AudienceCardSavedQueryDetails v-else-if="isSavedQuery" :audience="audience" class="mt-8" />
        <AudienceCardGaUserListDetails v-else-if="isGaUserList" :audience="audience" class="mt-8" />
      </template>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import AudienceCardFacebookDetails from './AudienceCardFacebookDetails.vue';
import AudienceCardSavedQueryDetails from './AudienceCardSavedQueryDetails.vue';
import AudienceCardGaUserListDetails from './AudienceCardGaUserListDetails.vue';

export default {
  components: {
    AudienceCardFacebookDetails,
    AudienceCardSavedQueryDetails,
    AudienceCardGaUserListDetails,
  },
  props: {
    audience: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFacebookAudience() {
      return (
        ['facebook_saved_audiences', 'facebook_custom_audiences'].indexOf(
          this.audience.model_type
        ) >= 0
      );
    },
    isSavedQuery() {
      return this.audience.model_type === 'saved_queries';
    },
    isGaUserList() {
      return this.audience.model_type === 'ga_user_list';
    },
  },
  methods: {
    getExcerpt(text, len) {
      if (typeof text !== 'string') {
        return text;
      }
      if (len > text.length - 1) {
        return text;
      }

      return `${text.substring(0, len)}...`;
    },
  },
};
</script>
